import React, { useContext, useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress, IconButton } from '@material-ui/core';
import { DriverAuthContext, navigate } from '../DriverApp';

const STATUS_LABELS = {
  planned: { label: 'Por iniciar', color: '#3b82f6', bg: '#dbeafe' },
  in_progress: { label: 'Em curso', color: '#f59e0b', bg: '#fef3c7' },
  completed: { label: 'Concluída', color: '#16a34a', bg: '#dcfce7' },
};

export default function DriverRoutes() {
  const { token, driver, logout, api } = useContext(DriverAuthContext);
  const [routes, setRoutes] = useState(null);
  const [error, setError] = useState('');

  async function load() {
    try {
      const res = await fetch(`${api}/mobile/my-routes`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error('Falha ao carregar');
      const data = await res.json();
      setRoutes(data);
    } catch (e) { setError(e.message); setRoutes([]); }
  }

  useEffect(() => { load(); }, []); // eslint-disable-line

  return (
    <Box style={{ minHeight: '100vh', background: '#f1f5f9', paddingBottom: 40 }}>
      {/* Header */}
      <Box style={{
        position: 'sticky', top: 0, zIndex: 10,
        background: 'linear-gradient(135deg, #3b82f6, #2563eb)', color: '#fff',
        padding: '18px 20px 14px', boxShadow: '0 2px 8px rgba(37,99,235,0.2)',
      }}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box>
            <Typography style={{ fontSize: '0.7rem', opacity: 0.85 }}>Olá,</Typography>
            <Typography style={{ fontSize: '1.1rem', fontWeight: 800 }}>{driver?.name || 'Motorista'}</Typography>
          </Box>
          <Button
            onClick={logout}
            style={{
              color: '#fff', textTransform: 'none', fontSize: '0.72rem', fontWeight: 600,
              border: '1px solid rgba(255,255,255,0.3)', padding: '4px 10px', borderRadius: 6,
            }}>
            Sair
          </Button>
        </Box>
      </Box>

      <Box style={{ padding: '16px 14px' }}>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <Typography style={{ fontSize: '0.9rem', fontWeight: 800, color: '#0f172a' }}>
            📋 As minhas rotas
          </Typography>
          <IconButton size="small" onClick={load} style={{ padding: 4 }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#64748b">
              <path d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/>
            </svg>
          </IconButton>
        </Box>

        {routes === null && (
          <Box style={{ textAlign: 'center', padding: 40 }}>
            <CircularProgress />
          </Box>
        )}

        {error && (
          <Box style={{ background: '#fee2e2', color: '#991b1b', padding: 12, borderRadius: 8, fontSize: '0.8rem' }}>
            {error}
          </Box>
        )}

        {routes !== null && routes.length === 0 && (
          <Box style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>
            <Typography style={{ fontSize: '0.9rem' }}>Sem rotas atribuídas.</Typography>
          </Box>
        )}

        {routes && routes.map(r => {
          const st = STATUS_LABELS[r.status] || { label: r.status, color: '#64748b', bg: '#f1f5f9' };
          const otCount = r.transportOrders?.length || 0;
          const distKm = r.totalDistanceM ? Math.round(r.totalDistanceM / 1000) : null;
          const durMin = r.totalDurationS ? Math.round(r.totalDurationS / 60) : null;
          return (
            <Box key={r.id}
              onClick={() => navigate(`/driver/routes/${r.id}`)}
              style={{
                background: '#fff', borderRadius: 14, padding: 14, marginBottom: 10,
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0',
                cursor: 'pointer', transition: 'transform 0.1s',
              }}
              onMouseDown={(e) => e.currentTarget.style.transform = 'scale(0.99)'}
              onMouseUp={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <Box style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 6 }}>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Typography style={{ fontSize: '0.95rem', fontWeight: 700, color: '#0f172a' }}>
                    {r.name || `Rota #${r.id}`}
                  </Typography>
                  <Typography style={{ fontSize: '0.7rem', color: '#64748b' }}>
                    {otCount} {otCount === 1 ? 'ordem' : 'ordens'}
                    {distKm && ` · ${distKm} km`}
                    {durMin && ` · ~${Math.floor(durMin / 60)}h${String(durMin % 60).padStart(2, '0')}`}
                  </Typography>
                </Box>
                <Box style={{
                  padding: '3px 10px', borderRadius: 10,
                  background: st.bg, color: st.color,
                  fontSize: '0.64rem', fontWeight: 700,
                }}>
                  {st.label}
                </Box>
              </Box>
              <Box style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6, fontSize: '0.7rem', color: '#334155' }}>
                <span style={{ color: '#16a34a' }}>▲</span> {r.origin?.name?.split(',')[0] || '—'}
                <span style={{ color: '#94a3b8', margin: '0 4px' }}>→</span>
                <span style={{ color: '#dc2626' }}>▼</span> {r.destination?.name?.split(',')[0] || '—'}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
